
import { isServer } from '@ulta/core/utils/device_detection/device_detection';
import { handleEmptyObjects } from '@ulta/core/utils/handleEmptyObjects/handleEmptyObjects';
import { getStorage, removeStorage, setStorage } from '@ulta/core/utils/storage/storage';
import { STORAGE_KEY } from '@ulta/core/utils/storageKeys/storageKeys';

/**
 * A pure functionto call post login to do RSVP action
 * @method
 * @param {Object} methods - Passing methods as an argument for the mutation call
 * @param {String} data - Passing data as an argument
 *
 */

export const composePostLoginRSVP = ( data, methods ) => () => {
  const { loading, hasCheckedPostLoginStatus = {}, loginStatus } = handleEmptyObjects( data );
  const { invokeMutation, handleActionAfter } = methods || {};

  if( loading || !loginStatus ){
    return;
  }

  // Always set to true, regardless of ATG/DSOTF status
  hasCheckedPostLoginStatus.current = true;
  // doing local storage operation
  const postLoginEventStoredData = getStorage( { secure: true, key: STORAGE_KEY.postLoginRsvpDetails } );
  removeStorage( { secure: true, key: STORAGE_KEY.postLoginRsvpDetails } );

  if( !postLoginEventStoredData || !invokeMutation ){
    return;
  }

  invokeMutation( {
    after: handleActionAfter,
    graphql: postLoginEventStoredData?.rsvpActionGraphql,
    customHeaders: postLoginEventStoredData?.rsvpCustomHeaders,
    params: postLoginEventStoredData?.rsvpParams,
    variables: {
      moduleParams: {
        eventId: postLoginEventStoredData?.eventId,
        eventData: postLoginEventStoredData?.eventData
      },
      url: { path: !isServer() && global.location.href }
    }
  } );
};

export const updateEventDetailPage = ( data, methods ) => () => {
  const { meta, eventId, id } = handleEmptyObjects( data );
  const { invokeAction } = methods || {};
  const initAction = meta?.initAction || {};
  if( !invokeAction || !id ){
    return;
  }

  const action = {
    graphql: initAction?.graphql,
    customHeaders: initAction?.customHeaders,
    method: initAction?.method,
    params: initAction?.params,
    variables: {
      contentId: id,
      moduleParams: {
        eventId: eventId
      }
    }
  };
  invokeAction( action );
};

export const composeApplyStoreFilter = ( data, methods ) => () => {
  const { store, id, applyStoreFilterAction, isGeolocationEnabled, userAppliedFiltersLength } = handleEmptyObjects( data );
  const { invokeAction } = methods || {};

  const shouldApplyDefaultStoreFilter = userAppliedFiltersLength === 0;

  if( !applyStoreFilterAction || !store || !invokeAction || !isGeolocationEnabled ){
    return ;
  }

  const defaultStore = { storeIds: store?.bopisStoreId };

  if( shouldApplyDefaultStoreFilter ){
    const action =  {
      graphql: applyStoreFilterAction?.graphql,
      customHeaders: applyStoreFilterAction?.customHeaders,
      params: applyStoreFilterAction?.params,
      method:applyStoreFilterAction.method,
      variables: {
        contentId: id,
        moduleParams: defaultStore,
        url: { path: !isServer() && global.location.href }
      }
    };

    invokeAction( action );
  }
};

/**
 * getUserAppliedFilterCount - takes in URLSearchParams and returns number of filters user applied that are not env or user-agent
 *
 * @method
 * @param {String} data - Passing data as an argument
 * @returns number of filters
 */
export const getUserAppliedFilterCount = ( data ) => {
  const { urlParams } = handleEmptyObjects( data );
  let userAppliedFilterCount = 0;
  for ( const [key, _] of urlParams ){
    if( key.toLowerCase() !== 'env' && key.toLowerCase() !== 'user-agent' ){
      userAppliedFilterCount++;
    }
  }
  return userAppliedFilterCount;
};